export function isLegacyCard(cardData) {
  if (!cardData) {
    return false;
  }
  return cardData.definition.cardType === 'LEGACY_SIDEBAR_CARD';
}